import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Alert } from '@/shared/ui/Alert';
import { Button } from '@/shared/ui/Button';

/** Rota seviyesinde yakalanan hatalar için sade sayfa (React Router varsayılanı yerine). */
export function RouteErrorPage() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);
  return (
    <div className="mx-auto max-w-lg p-6">
      <Alert tone="danger">{message}</Alert>
      <Button className="mt-4" variant="secondary" onClick={() => window.location.assign('/')}>
        Ana sayfa
      </Button>
    </div>
  );
}
